import ScriptHelper from "base/ScriptHelper";
import ValueHelper from "base/ValueHelper";
import TrackingHelper from "webPage/TrackingHelper";

export function loadHubspot() {
    return TrackingHelper.wait().then(() => ScriptHelper.load_script("https://js.hsforms.net/forms/shell.js"));
}

window.hubspotStyles = null;
window.hubspotLoaded = false;

export function handleHubspotForm($container, callback = null) {
    let redirectUrl = $container.find('.js-hubspot-container').data('hubspot-redirect-url');

    if('undefined' === typeof redirectUrl){
        redirectUrl = null;
    }

    if (window.hubspotStyles === null) {
        $.ajax('/wp-content/themes/aws-microsite-theme/css/hubspot-styles.css?v=1.3', {
            type: 'GET',
            dataType: "html",
        }).done((data) => {
            window.hubspotStyles = data;
            if (window.hubspotLoaded) {
                createHubspotForm($container, callback, redirectUrl);
            }
        });
    }

    loadHubspot().then(() => {
        window.hubspotLoaded = true;
        if (window.hubspotStyles !== null) {
            createHubspotForm($container, callback, redirectUrl);
        }
    });
}

export function createHubspotForm($container, callback, redirectUrl) {
    let loaded = false;

    let $hubspotForm;
    let $hubspot = $container.find(".js-hubspot-container");

    let $form = $container.find("form");

    if ($form.length === 0) {
        $form = $container.closest("form");
    }

    let formClass = $hubspot.attr('data-hubspot-class');

    let id = "hubspot-form-" + ValueHelper.random_string();
    $hubspot.attr("id", id);
    let portalId = $hubspot.attr("data-portal-id");
    let formId = $hubspot.attr("data-form-id");

    console.log(portalId, formId);

    let options = {
        portalId,
        formId,
        target: "#" + id,
        onFormReady: ($form) => {
            $hubspotForm = $form;
            loaded = true;
            $form.find("input,textarea,select").trigger("hubspot-update");
            $form.addClass(formClass).closest('.hbspt-form').addClass(formClass);
            console.log($form);
        },
        cssRequired: window.hubspotStyles,
    };

    if (callback !== null) {
        options.onFormSubmitted = callback;
    }

    if (redirectUrl !== null) {
        options.redirectUrl = redirectUrl;
    }

    hbspt.forms.create(
        options,
    );
}
